import React, { useState, useEffect, memo } from 'react';
import { useFormikContext } from 'formik';
import ToggleSelect from '../../../../common/components/ToggleSelect/ToggleSelect';
import doctor from '../../../../images/icons/SEP/doctor.svg';
import CA_CS from '../../../../images/icons/SEP/CA_CS.svg';
import architect from '../../../../images/icons/SEP/architect.svg';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import get from 'lodash/get';
import styles from './SEP.module.css';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import initialImg from '../../../../images/icons/upload_new.svg';
import {
  getDropDownOptionsAPI,
  getMedicalCouncilAPI,
  SEPsaveAPI,
  getSEPProfessionAPI,
  SEPUploadCertificateAPI,
  SEPUploadedCertificateAPI,
  UploadFileToS3,
  getSEPCertificateAPI
} from '../../../../common/constants/api';
import withErrorHandler from '../../../../hoc/withErrorHandler/withErrorHandler';
import PopUp from '../../../../common/components/PopUp/PopUp';

import moment from 'moment';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import _, { stubFalse } from 'lodash';

const { doctorContainer, CAContainer } = styles;

const SEPProfession = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    setValues
  } = useFormikContext();

  const [originalProfessionType, setoriginalProfessionType] = useState('');
  const [Edit1, setEdit1] = useState(false);
  const [imgLinkData, setImgLinkData] = useState(null);
  const [profession, setProfession] = useState('');
  const [medicalQualification, setMedicalQualification] = useState([]);
  const [medicalCouncilOptions, setMedicalCouncilOptions] = useState([]);
  const [CA_CS_ICWAIQualification, setCA_CS_ICWAIQualification] = useState([]);

  const isDoctor = profession === 'Doctor';
  const is_CA_CS_ICWAI = profession === 'CA/CS/ICWAI';
  const isArchitect = profession === 'Architect';
  const isDoctorMBBS = values.doctorQualification.value === 1;
  const isCS = values?.CA_CS_ICWAI_Qualification?.value === 9;
  const [type, setType] = useState('loading');
  const [text, setText] = useState('Loading...');
  const [show, setShow] = useState(false);

  useEffect(() => {
    getDropDownOptionsAPI('Medical')
      .then(res => {
        setMedicalQualification(res);
      })
      .catch(err => {});
    getDropDownOptionsAPI('Accounting')
      .then(res => {
        setCA_CS_ICWAIQualification(res);
      })
      .catch(err => {});
    getMedicalCouncilAPI()
      .then(res => {
        setMedicalCouncilOptions(res);
      })
      .catch(err => {});
  }, []);

  useEffect(() => {
    getSEPProfessionAPI(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        setoriginalProfessionType(res?.profession);
        setValues({
          ...values,
          professionType: res?.profession,
          doctorQualification:
            res?.profession === 'Doctor'
              ? {
                  label: res?.professionalQualification?.name,
                  value: res?.professionalQualification?.id
                }
              : {
                  label: 'Select Qualification',
                  value: ''
                },
          doctorRegistrationNumber:
            res?.profession === 'Doctor'
              ? res?.professionRegistrationNumber
              : '',
          doctorRegistrationYear: res?.professionRegisteredYear
            ? {
                label: moment(res?.professionRegisteredYear).format('YYYY'),
                value: moment(res?.professionRegisteredYear).format('YYYY')
              }
            : {
                label: 'Years of registration',
                value: ''
              },
          medicalCouncil: res?.medicalCouncil?.id
            ? {
                label: res?.medicalCouncil?.name,
                value: res?.medicalCouncil?.id
              }
            : {
                label: 'Select Medical council',
                value: ''
              },
          CA_CS_ICWAI_Qualification:
            res?.profession === 'CA/CS/ICWAI'
              ? {
                  label: res?.professionalQualification?.name,
                  value: res?.professionalQualification?.id
                }
              : {
                  label: 'Select Qualification',
                  value: ''
                },
          CA_CS_ICWAI_MemberShipNo:
            res?.profession === 'CA/CS/ICWAI'
              ? res?.professionRegistrationNumber
              : '',
          CA_CS_ICWAI_CpNumber: res?.cpNumber || ''
        });
      })
      .catch(err => {});
  }, []);

  useEffect(() => {
    getSEPCertificateAPI(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        if (res?.links?.[0]) {
          setFieldValue('isEditMode', true);
        }
        setImgLinkData(res?.links?.[0]);
      })
      .catch(err => {});
  }, []);
  async function fileUpload() {
    setType('loading');
    setText('Uploading the File Please Wait...');
    setShow(true);
    await SEPUploadCertificateAPI(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        UploadFileToS3(res.url, values.file[0][0]).then(() => {
          SEPUploadedCertificateAPI(
            getApplicantionInfo().leadId,
            getApplicantionInfo().leadApplicantId,
            res?.requestId || ''
          ).then(res => {
            setType('success');
            setText('Uploaded the File successfully.');

            setShow(false);
          });
        });
      })
      .catch(err => {});
  }
  useEffect(() => {
    if (values.file[0] && values.file[0][0]) {
      fileUpload();
    }
  }, [values.file[0]]);
  function qualificationOptionsFun() {
    return medicalQualification.map(each => {
      return {
        label: `${each.name} - (${each.code})`,
        value: each.id
      };
    });
  }
  function CA_QualificationOptionsFun() {
    return CA_CS_ICWAIQualification.map(each => {
      return {
        label: each.name,
        value: each.id
      };
    });
  }

  function medicalCouncilOptionsFun() {
    return medicalCouncilOptions.map(each => {
      return {
        label: each.name,
        value: each.id
      };
    });
  }

  function getYearOfRegistrationList() {
    let listOfYear = [];
    for (let i = parseInt(moment().year()); i > 1946; i--) {
      listOfYear.push(i);
    }
    return listOfYear.map(each => {
      return {
        label: `${each}`,
        value: each
      };
    });
  }

  function SEPFun() {
    //'2020-08-31T08:38:50.876Z',
    let body = {};
    if (values.professionType === 'Doctor') {
      body = {
        profession: values?.professionType,
        professionalQualification: values?.doctorQualification?.value,
        professionRegistrationNumber: values?.doctorRegistrationNumber,
        professionRegisteredYear: values?.doctorRegistrationYear?.value,
        medicalCouncil: values?.medicalCouncil?.value
      };
    } else if (values.professionType === 'CA/CS/ICWAI') {
      body = {
        profession: values?.professionType,
        professionalQualification: values?.CA_CS_ICWAI_Qualification?.value,
        professionRegistrationNumber: values?.CA_CS_ICWAI_MemberShipNo,
        cpNumber: values?.CA_CS_ICWAI_CpNumber
      };
    } else if (values.professionType === 'Architect') {
      body = {
        profession: values?.professionType
      };
    }

    SEPsaveAPI(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId,
      body
    )
      .then(res => {})
      .catch(error => {});
  }

  useEffect(() => {
    return () => {
      setFieldValue('file', []);
      setFieldValue('imgUrl', []);
    };
  }, []);
  return (
    <React.Fragment>
      <div className="md:ml-3 lg:ml-6">
        <p className="font-roboto font-medium text-base text-black-850 my-6 pl-2">
          Choose Your Profession
        </p>
        <div className="flex">
          <div className="pr-4 cursor-pointer">
            <ToggleSelect
              img={doctor}
              name="professionType"
              value="Doctor"
              nameDisplay="Doctor"
              checked={values.professionType === 'Doctor'}
              onChange={e => {
                setFieldValue('professionType', e.target.value);
                setProfession('Doctor');
              }}
              namingStyle={{
                paddingTop: '16px',
                color: isDoctor ? '#00ACB8' : '#7B8C9B'
              }}
            />
          </div>
          <div className="pr-4 cursor-pointer">
            <ToggleSelect
              img={CA_CS}
              name="professionType"
              value="CA/CS/ICWAI"
              nameDisplay="CA/CS/ICWAI"
              checked={values.professionType === 'CA/CS/ICWAI'}
              onChange={e => {
                setFieldValue('professionType', e.target.value);
                setProfession('CA/CS/ICWAI');
              }}
              namingStyle={{
                paddingTop: '16px',
                position: 'relative',
                left: '-10px',
                color: is_CA_CS_ICWAI ? '#00ACB8' : '#7B8C9B'
              }}
            />
          </div>
          <div className="cursor-pointer">
            <ToggleSelect
              img={architect}
              name="professionType"
              value="Architect"
              nameDisplay="Architect"
              checked={values.professionType === 'Architect'}
              onChange={e => {
                setFieldValue('professionType', e.target.value);
                setProfession('Architect');
              }}
              namingStyle={{
                paddingTop: '16px',
                color: isArchitect ? '#00ACB8' : '#7B8C9B'
              }}
            />
          </div>
        </div>

        {(isDoctor || values?.professionType === 'Doctor') && (
          <div className={`${doctorContainer}  mt-14`}>
            <CommonSelect sort={true}
              name="doctorQualification"
              value={values.doctorQualification}
              onChange={anyvalue => {
                setFieldValue('doctorQualification', anyvalue, true);
                setFieldTouched('doctorQualification', true, false);
              }}
              options={qualificationOptionsFun()}
              stylesContainer={{
                height: '52px',
                marginBottom: '40px',
                fontSize: '40px'
              }}
              dropdownStyle={{
                top: '55px'
              }}
              styleText={{
                fontSize: '14px',
                padding: '0 25px'
              }}
              error={
                touched.doctorQualification &&
                get(errors, 'doctorQualification.value', false)
              }
              errorMsg={get(errors, 'doctorQualification.value', false)}
              touched={touched.doctorQualification}
            />

            {(isDoctorMBBS || values?.doctorQualification?.value == 1) && (
              <>
                <CommonInput
                  name="doctorRegistrationNumber"
                  onChange={e => {
                    handleChange(e);
                    setFieldValue('doctorRegistrationNumber', e.target.value);
                  }}
                  onBlur={e => {
                    handleBlur(e);
                  }}
                  value={values.doctorRegistrationNumber}
                  stylesContainer={{
                    maxWidth: '100%',
                    marginBottom: '40px'
                  }}
                  legendName="Enter Registration Number"
                  error={
                    touched.doctorRegistrationNumber &&
                    errors.doctorRegistrationNumber
                  }
                  errorMsg={errors.doctorRegistrationNumber}
                  touched={touched.doctorRegistrationNumber}
                />
                <CommonSelect sort={true}
                  name="doctorRegistrationYear"
                  value={values.doctorRegistrationYear}
                  onChange={anyvalue => {
                    setFieldValue('doctorRegistrationYear', anyvalue, true);
                    setFieldTouched('doctorRegistrationYear', true, false);
                  }}
                  options={getYearOfRegistrationList()}
                  stylesContainer={{
                    height: '52px',
                    marginBottom: '40px',
                    fontSize: '40px'
                  }}
                  dropdownStyle={{
                    top: '55px'
                  }}
                  styleText={{
                    fontSize: '14px',
                    padding: '0 25px'
                  }}
                  error={
                    touched.doctorRegistrationYear &&
                    get(errors, 'doctorRegistrationYear.value', false)
                  }
                  errorMsg={get(errors, 'doctorRegistrationYear.value', false)}
                  touched={touched.doctorRegistrationYear}
                />

                <CommonSelect sort={true}
                  name="medicalCouncil"
                  value={values.medicalCouncil}
                  onChange={anyvalue => {
                    setFieldValue('medicalCouncil', anyvalue, true);
                    setFieldTouched('medicalCouncil', true, false);
                  }}
                  options={medicalCouncilOptionsFun()}
                  stylesContainer={{
                    height: '52px',
                    marginBottom: '40px',
                    fontSize: '40px'
                  }}
                  dropdownStyle={{
                    top: '55px'
                  }}
                  styleText={{
                    fontSize: '14px',
                    padding: '0 25px'
                  }}
                  error={
                    touched.medicalCouncil &&
                    get(errors, 'medicalCouncil.value', false)
                  }
                  errorMsg={get(errors, 'medicalCouncil.value', false)}
                  touched={touched.medicalCouncil}
                />
              </>
            )}
          </div>
        )}

        {(is_CA_CS_ICWAI || values?.professionType === 'CA/CS/ICWAI') && (
          <div className={`${CAContainer} mt-14`}>
            <CommonSelect sort={true}
              name="CA_CS_ICWAI_Qualification"
              value={values.CA_CS_ICWAI_Qualification}
              onChange={anyvalue => {
                setFieldValue('CA_CS_ICWAI_Qualification', anyvalue, true);
                setFieldTouched('CA_CS_ICWAI_Qualification', true, false);
              }}
              options={CA_QualificationOptionsFun()}
              stylesContainer={{
                height: '52px',
                marginBottom: '40px',
                fontSize: '40px'
              }}
              dropdownStyle={{
                top: '55px'
              }}
              styleText={{
                fontSize: '14px',
                padding: '0 25px'
              }}
              error={
                touched.CA_CS_ICWAI_Qualification &&
                get(errors, 'CA_CS_ICWAI_Qualification.value', false)
              }
              errorMsg={get(errors, 'CA_CS_ICWAI_Qualification.value', false)}
              touched={touched.CA_CS_ICWAI_Qualification}
            />
            <CommonInput
              name="CA_CS_ICWAI_MemberShipNo"
              onChange={e => {
                handleChange(e);
                setFieldValue('CA_CS_ICWAI_MemberShipNo', e.target.value);
              }}
              onBlur={e => {
                handleBlur(e);
              }}
              value={values.CA_CS_ICWAI_MemberShipNo}
              stylesContainer={{
                maxWidth: '100%',
                marginBottom: '40px'
              }}
              legendName="Enter Membership Number"
              error={
                touched.CA_CS_ICWAI_MemberShipNo &&
                errors.CA_CS_ICWAI_MemberShipNo
              }
              errorMsg={errors.CA_CS_ICWAI_MemberShipNo}
              touched={touched.CA_CS_ICWAI_MemberShipNo}
            />
            {isCS && (
              <CommonInput
                name="CA_CS_ICWAI_CpNumber"
                onChange={e => {
                  handleChange(e);
                  setFieldValue('CA_CS_ICWAI_CpNumber', e.target.value);
                }}
                onBlur={e => {
                  handleBlur(e);
                }}
                value={values.CA_CS_ICWAI_CpNumber}
                stylesContainer={{
                  maxWidth: '100%',
                  marginBottom: '40px'
                }}
                legendName="CP Number"
                error={
                  touched.CA_CS_ICWAI_CpNumber && errors.CA_CS_ICWAI_CpNumber
                }
                errorMsg={errors.CA_CS_ICWAI_CpNumber}
                touched={touched.CA_CS_ICWAI_CpNumber}
              />
            )}
          </div>
        )}
        {(profession || values.professionType) && (
          <>
            <div className="mt-12">
              <p className="font-roboto font-medium md:text-base text-black-1011 my-4  pl-2">
                {isDoctor
                  ? 'Upload Registration Certification'
                  : 'Upload Membership Certification'}
              </p>
              <div
                className="bg-white  flex justify-center rounded-lg border border-navy-200 md:border-none
                        py-9  pr-5  md:py-0 md:pl-0 md:pr-0 w-64 md:w-full"
              >
                {imgLinkData?.url && !Edit1 ? (
                  <div className="md:mr-auto md:ml-3 ">
                    <ShowGetImage img={imgLinkData?.url} setEdit={setEdit1} />
                  </div>
                ) : (
                  <GlobalUploadComp
                    data={values}
                    imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    initialImg={initialImg} // initial image
                    subInst="Click here to upload"
                    subtext="CHOOSE IMAGE"
                  />
                )}
              </div>
            </div>

            <div className="mt-12">
              <button
                onClick={() => {
                  SEPFun();
                }}
                type="submit"
                disabled={
                  !_.isEmpty(errors) ||
                  (!_.get(values, 'file.0.0', false) && !imgLinkData?.url)
                }
                className="submitButton w-56 mb-6"
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
      <PopUp type={type} text={text} setShow={setShow} show={show} />
    </React.Fragment>
  );
};
export default memo(withErrorHandler(SEPProfession));
